import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Snackbar from '@material-ui/core/Snackbar';

// import Email from "@material-ui/icons/Email";

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";

import CustomNotification from "../LandingPage/Sections/CustomNotification";

import loginPageStyle from "../../assets/jss/material-kit-pro-react/views/loginPageStyle.jsx";

import { requestNewPassword } from '../../actions/authActions';
import bgImg from "../../assets/img/landing-bg.jpg";

class RequestResetPage extends React.Component {
    constructor() {
        super();
        this.state = {
            openNotification: false,
            variantNotification: '',
            messageNotification: '',
            username: '',
            errors: {}
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!!nextProps.errors && !!nextProps.errors.message) {
            this.handleClickNotification(nextProps.errors.message, 'error');
            let errors = {};
            if (!!nextProps.errors.errors && nextProps.errors.errors.length>0) {
                for (let i=0; i<nextProps.errors.errors.length; i++) {
                    let actualField = nextProps.errors.errors[i];
                    errors[actualField.field] = actualField.message;
                }
                this.setState({ errors });
            }
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        const { location } = this.props;

        if (!!location.state && !!location.state.message) {
            this.handleClickNotification(location.state.message, location.state.type);
        }
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    onChangeCustomInput = () => e => {
        if (!!e.target.id) {
            this.setState({ [e.target.id]: e.target.value, errors: {} });
        } else {
            console.error('Error actualizando la informacion ingresada', 'error');
        }
    };

    onSubmit = e => {
        e.preventDefault();

        let { username } = this.state;

        this.props.requestNewPassword(username, this.props.history);
    };

    render() {
        const { classes } = this.props;
        const { errors } = this.state;

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Solicitar cambio de contraseña | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 180,
                        color: "white"
                    }}
                />
                <div
                    className={classes.pageHeader}
                    style={{ backgroundImage: "url(" + bgImg + ")", backgroundSize: "cover", backgroundPosition: "top center" }}
                >
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={4}>
                                <Card>
                                    {/* Custom Notification */}
                                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                                        <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                                    </Snackbar>
                                    {/* End Custom Notification */}

                                    <form className={classes.form} onSubmit={this.onSubmit}>
                                        <CardHeader color="success" signup className={classes.cardHeader}>
                                            <h4 className={classes.cardTitle}>Reestablecer mi contraseña</h4>
                                        </CardHeader>

                                        <CardBody signup>
                                            <div className={classes.textCenter}>
                                                <h5>Ingresa tu dirección de correo o tu nombre de usuario. Las instrucciones para la recuperación de tu contraseña serán enviadas a tu email</h5>
                                            </div>
                                            <CustomInput
                                                id="username"
                                                labelText= {!!errors.username ? errors.username : "Email o nombre de usuario"}
                                                error = {!!errors.username}
                                                formControlProps={{ fullWidth: true }}
                                                inputProps={{
                                                    type: "text",
                                                    defaultValue: this.state.username,
                                                    onChange: this.onChangeCustomInput(),
                                                    required: true
                                                }}
                                            />
                                        </CardBody>

                                        <br/>

                                        <div className={classes.textCenter}>
                                            <Button round color="success" type="submit">
                                                Enviar
                                            </Button>
                                        </div>

                                        <br/>
                                    </form>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div>

                    <Footer
                        className={classes.footer}
                        content={
                            <div>
                                <div className={classes.left}>
                                    <List className={classes.list}>
                                        <ListItem className={classes.inlineBlock}>
                                            <Link to="/" className={classes.block}> Inicio </Link>
                                        </ListItem>
                                        <ListItem className={classes.inlineBlock}>
                                            <Link to="/signup" className={classes.block}> Registrarse </Link>
                                        </ListItem>
                                        <ListItem className={classes.inlineBlock}>
                                            <Link to="/contacto" className={classes.block}> Contacto </Link>
                                        </ListItem>
                                    </List>
                                </div>

                                <div className={classes.right}>&copy; {1900 + new Date().getYear()} Vivamos el Campo. Todos los derechos reservados.</div>
                            </div>
                        }
                    />
                </div>
            </div>
        );
    }
}

RequestResetPage.propTypes = {
    requestNewPassword: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    errors: state.errors
});

export default connect(mapStateToProps, { requestNewPassword })( withStyles(loginPageStyle)(RequestResetPage) );



// WEBPACK FOOTER //
// ./src/views/LoginPage/RequestResetPage.jsx